export const FIELD_NAMES = {
  WAITING_CONDITIONS: 'waitingConditions',
} as const;

export const FIELD_NAMES_VALUES = Object.values(FIELD_NAMES);
